// This would come from an api and a database in this shape

const data = {
  የተመረጠ: [
    {
      id: 1,
      avatar: 'በ',
      title: 'በኮመርስ ከቦታው መነሳት ጉዳይ',
      date: 'ነሀሴ 8 2013',
      img: 'https://www.addisadmassnews.com/media/k2/items/cache/30a2d3687e1a6b180b4da708b3792271_XL.jpg',
      image_title: 'በኮመርስ ከቦታው መነሳት ጉዳይ',
      description:
        'ዶ/ር  ወርቁ መኮንን ኮመርስ (የንግድ ሥራ ኮሌጅ) ከቦታው መነሳቱን በመቃወም፣ በሪፖርተር ጋዜጣ ሐምሌ 25 ቀን 2013 ዓ.ም የተወሰኑ ውሀ የማይቋጥሩ ነጥቦችን አስቀምጠዋል።',
      content:
        'ዶ/ር  ወርቁ መኮንን ኮመርስ ከቦታው መነሳቱን በመቃወም፣ በሪፖርተር ጋዜጣ ሐምሌ 25 ቀን 2013 ዓ.ም የተወሰኑ ውሀ የማይቋጥሩ ነጥቦችን አስቀምጠዋል። መነሳታቸው አግባብነት ያለውና መንግስት ወደፊትም በሌሎችም በጥናት ላይ ተመስርቶ እንዲያድሱ፣ ደረጃውን የጠበቀ ህንፃ እንዲገነቡና ቦታ እንዲቀይሩ ማድረግ ይጠበቅበታል። ይህም አዲስ አበባን፣ አዲስ አበባ የማድረግ ወሳኝ ተግባር ሲሆን እንደ ኮመርስ ያሉ ተቋማት ላይ ግን የተወሰደው እርምጃ ቢዘገይም ትክክለኛነቱን መጥቀስ ያስፈልጋል። ተቋሙ እንደ ስሙ እድሜውና የያዘው ትልቅ ስፍራ የቆሻሻ መጣያ የመሰለ፣ ውስጡና ውጭው የቆሸሸ፣ ገፅታን የሚያበላሽ፣ ለተማሪው የማይመጥን አሳፋሪ ስፍራ የነበረ መሆኑ ያደባባይ ሚስጢር ነው። አዲስ አበባ በጀመረችው የከተማ ለውጥ ጉዞ ተገቢውን ድጋፍ በማድረግ፣ የከተማችንን ውበት እውን ማድረግ በሁለንተናዊ ቅንጅታዊ ስራ በመሆኑ፣ የረባ ያልረባ ምክንያት መፍጠር ሳይሆን የመፍትሄ አካል መሆን ይገባል። ለውጥ ሲኖር ነውጥ መኖሩ ግር ሳይለው በቀጣይም መንግስት ከተማዋን ለማዘመን የሚታደሱ፣ የሚፈርሱ ብሎም የሚሸጋሸጉ ተቋማት መኖራቸውን የቅድመ ግንዛቤ ስራ በመስራት፣ ኢትዮጵያን የአለም ቱሪስቶች ግንባር ቀደም መስህብ ማድረግ ያስፈልጋል።',
      mediaSource: 'rec',
      url: '/feeds/1',
    },
    {
      id: 2,
      avatar: 'መ',
      title: 'በአዲስ አበባ ከ350 በላይ መንደሮች ለጎርፍ አደጋ ተጋላጭ ናቸው',
      date: 'ነሀሴ 1 2013',
      img: 'https://www.addisadmassnews.com/media/k2/items/cache/87cc6fa38765b3c92cbd564327595627_XL.jpg',
      image_title: 'Mel Ario',
      description:
        'ማክሰኞ ነሐሴ 11 ቀን 2013 ዓ.ም። ዕለቱ ለመካኒሣው መካነኢየሱስ ሴሚናሪያ መንደር ነዋሪዎች ጥቁር ቀን ነበር።… ከቀናቶች ሁሉ የከፋ ...',
      content: `እናትና አባት ከእነልጅ ልጆቻቸው በጎርፍ ተወስደዋል እናትና አባት ከእነልጅ ልጆቻቸው በጎርፍ ተወስደዋል
      - ደራሽ ውሃው የአስር ዓመቷን ታዳጊ ከአባቷ እቅፍ ነጥቆ ወስዷታል
     - ጎርፉ መንትያ ወንድማማቾችን ነጥሏል፣ የቤት ሰራተኛዋን ከእነታቀፈችው ህፃን ለሞት  ዳርጓል።
      ዕለቱ ለመካኒሣው መካነኢየሱስ ሴሚናሪያ መንደር ነዋሪዎች ጥቁር ቀን ነበር።… ከቀናቶች ሁሉ የከፋ።
 ቤዛ በዚህ መንደር ኑሮዋንም ስራዋንም ካደረገች ጥቂት ዓመታት ተቆጥረዋል። በስራ ምክንያት ለጊዜው አጠገቧ ያልነበረው ባለቤቷ፣ የሷንና የልጆቿን ደህንነት እየደጋገመ በስልክ ከመጠየቅ አልቦዘነም። ነዋሪነታቸው በደቡብ ክልል ከንባታ ከተማ ውስጥ የሆኑት የቤዛ እናትና አባት፣ በዚህች መንደር በዛች ጥቁር ቀን የተገኙ ወደ አሜሪካ  ለሚያደርጉት ጉዞ ለመዘገጃጀትና ልጃቸውን ለመሰናበት ነበር። ቤዛ እናትና አባቷን በደስታ ተቀብላና በሚገባ አስተናግዳ እዛው ሴሚናሪያ ግቢ ውስጥ ወደሚገኘው የስራ ቦታዋ ደረስ ብላ ለመመለስ ከቤት ትወጣለች። ሰዓቱ ከቀኑ ዘጠኝ ሰዓት ተኩል ገደማ ይሆናል። በእነ ቤዛ ቤት አሜሪካ አገር የምትኖር ልጃቸውን ለማየት የናፈቁ እናትና አባቷ፣ የቤዛ መንትያ ልጆች፣ የአንድ እህቷ ልጅና የቤት ሰራተኛዋ ነበሩ። መንደሩ ከትልቁ የመካኒሣ ወንዝ አጠገብ የከተመ መንደር በመሆኑ ባለፉት ዓመታት በተደጋጋሚ ቀላል ጎርፎችን ያስተናገደ ቢሆንም፣ የከፋ ችግር ሊያስከትል ይችላል ብሎ ያሰበም የጠረጠረም አልነበረም በድንገት የእነ ቤዛ መንደር ታይቶ በማይታወቅ ከባድና አስፈሪ ደራሽ ጎርፍ ተጥለቀለቀ። የመንደሩ ነዋሪዎች ራሳቸውንና ቤተሰቦቻቸውን እንደ ፈረስ ከሚጋልበው የጎርፍ መዓት ለማትረፍ ተራወጡ። ጎርፉ የእነ ቤዛን ቤት ገነጣጥሎ ለመግባት የወሰደበት ጥቂት ቅፅበት ብቻ ነበር።
 ያገኘውን ሁሉ እያፈነቃቀለና እያተራመሰ ወስዶ ከትልቁ የመካኒሳ ወንዝ የሚደባልቀው ደራሽ ጎርፍ እነቤዛ ቤት ላይ የጭካኔ በትሩን አሳረፈ። እንኳን ቤተኞቹን እንግዶቹንም አልማረም። ከመኖሪያ ቤቷ በጥቂት ርቀት ላይ  የነበረችው ቤዛ፤ እቤቷ ደርሳ ቤተሰቦቿን ከሞት ለመታደግ አልቻለችም። ሁሉም ነገር ቅፅበታዊና ዘግናኝ ነበር። እናቷን፣ አባቷን ከመንትያ ልጆቿ አንዱን፣ የእህቷን ልጅና የቤት ሰራተኛዋን ደራሹ ጎርፍ ነጠቃት።
 ከሁለቱ መንትያ ልጆቿ አንዱን ተአምር ሊያሰኝ በሚችል ሁኔታ ያተረፉላት የነፍስ አድን ዋናተኞች ናቸው። ከጥቂት ሰዓታት በፊት የልጅ ልጆቻቸውን በስስት እያዩ በሚያጫውቱ አያቶች፣ በጣፋጭ የልጅ አንደበታቸው ቤቱን በሳቅ ጨዋታ በሚያደምቁ እምቦቀቅላዎች ደምቆ የነበረው የእነ ቤዛ ቤት አስፈሪ የሞት ጥላ አጠላበት። አምስት ነፍሶች ተነጠቁበት። በጎርፍ ፍርስርሱ ወጣ።- 
      ደራሽ ውሃው የአስር ዓመቷን ታዳጊ ከአባቷ እቅፍ ነጥቆ ወስዷታል 
      - ጎርፉ መንትያ ወንድማማቾችን ነጥሏል፣ የቤት ሰራተኛዋን ከእነታቀፈችው ህፃን ለሞት ዳርጓል። ዕለቱ ለመካኒሣው መካነኢየሱስ ሴሚናሪያ መንደር ነዋሪዎች ጥቁር ቀን ነበር።… ከቀናቶች ሁሉ የከፋ። ቤዛ በዚህ መንደር ኑሮዋንም ስራዋንም ካደረገች ጥቂት ዓመታት ተቆጥረዋል። በስራ ምክንያት ለጊዜው አጠገቧ ያልነበረው ባለቤቷ፣ የሷንና የልጆቿን ደህንነት እየደጋገመ በስልክ ከመጠየቅ አልቦዘነም። ነዋሪነታቸው በደቡብ ክልል ከንባታ ከተማ ውስጥ የሆኑት የቤዛ እናትና አባት፣ በዚህች መንደር በዛች ጥቁር ቀን የተገኙ ወደ አሜሪካ ለሚያደርጉት ጉዞ ለመዘገጃጀትና ልጃቸውን ለመሰናበት ነበር። ቤዛ እናትና አባቷን በደስታ ተቀብላና በሚገባ አስተናግዳ እዛው ሴሚናሪያ ግቢ ውስጥ ወደሚገኘው የስራ ቦታዋ ደረስ ብላ ለመመለስ ከቤት ትወጣለች። ሰዓቱ ከቀኑ ዘጠኝ ሰዓት ተኩል ገደማ ይሆናል። በእነ ቤዛ ቤት አሜሪካ አገር የምትኖር ልጃቸውን ለማየት የናፈቁ እናትና አባቷ፣ የቤዛ መንትያ ልጆች፣ የአንድ እህቷ ልጅና የቤት ሰራተኛዋ ነበሩ። መንደሩ ከትልቁ የመካኒሣ ወንዝ አጠገብ የከተመ መንደር በመሆኑ ባለፉት ዓመታት በተደጋጋሚ ቀላል ጎርፎችን ያስተናገደ ቢሆንም፣ የከፋ ችግር ሊያስከትል ይችላል ብሎ ያሰበም የጠረጠረም አልነበረም በድንገት የእነ ቤዛ መንደር ታይቶ በማይታወቅ ከባድና አስፈሪ ደራሽ ጎርፍ ተጥለቀለቀ። የመንደሩ ነዋሪዎች ራሳቸውንና ቤተሰቦቻቸውን እንደ ፈረስ ከሚጋልበው የጎርፍ መዓት ለማትረፍ ተራወጡ። ጎርፉ የእነ ቤዛን ቤት ገነጣጥሎ ለመግባት የወሰደበት ጥቂት ቅፅበት ብቻ ነበር። ያገኘውን ሁሉ እያፈነቃቀለና እያተራመሰ ወስዶ ከትልቁ የመካኒሳ ወንዝ የሚደባልቀው ደራሽ ጎርፍ እነቤዛ ቤት ላይ የጭካኔ በትሩን አሳረፈ። እንኳን ቤተኞቹን እንግዶቹንም አልማረም። ከመኖሪያ ቤቷ በጥቂት ርቀት ላይ የነበረችው ቤዛ፤ እቤቷ ደርሳ ቤተሰቦቿን ከሞት ለመታደግ አልቻለችም። ሁሉም ነገር ቅፅበታዊና ዘግናኝ ነበር። እናቷን፣ አባቷን ከመንትያ ልጆቿ አንዱን፣ የእህቷን ልጅና የቤት ሰራተኛዋን ደራሹ ጎርፍ ነጠቃት። ከሁለቱ መንትያ ልጆቿ አንዱን ተአምር ሊያሰኝ በሚችል ሁኔታ ያተረፉላት የነፍስ አድን ዋናተኞች ናቸው። ከጥቂት ሰዓታት በፊት የልጅ ልጆቻቸውን በስስት እያዩ በሚያጫውቱ አያቶች፣ በጣፋጭ የልጅ አንደበታቸው ቤቱን በሳቅ ጨዋታ በሚያደምቁ እምቦቀቅላዎች ደምቆ የነበረው የእነ ቤዛ ቤት አስፈሪ የሞት ጥላ አጠላበት። አምስት ነፍሶች ተነጠቁበት። በጎርፍ ፍርስርሱ ወጣ።`,
      mediaSource: 'rec1',
      url: '/feeds/2',
    },

    {
      id: 3,
      avatar: 'ዲ',
      title: 'አዲሱ የአሜሪካ ማዕቀብና ከኢትዮጵያ የገጠመው ተቃውሞ',
      date: 'መስከረም  6 2014',
      img: 'https://www.addisadmassnews.com/media/k2/items/cache/d6ded7a95ea8e79c843fe8511d0a29a4_XL.jpg',
      image_title: 'corpus mortus',
      description:
        'በአሜሪካው ፕሬዚዳንት ጆ ባይደን በቅርቡ የተፈረመውና ኢትዮጵያ ውስጥ የተቀሰቀሰው ግጭት እንዲራዘም ሰበብ በሚሆኑ ተጠያቂዎችና ተባባሪዎቻቸው...፡',
      content: `በአሜሪካው ፕሬዚዳንት ጆ ባይደን በቅርቡ የተፈረመውና ኢትዮጵያ ውስጥ የተቀሰቀሰው ግጭት እንዲራዘም ሰበብ በሚሆኑ ተጠያቂዎችና ተባባሪዎቻቸው ላይ አዲስ ማዕቀብ ለመጣል ያስችላል የተባለው ትዕዛዝ፣ ከኢትዮጵያ ከፍተኛ ተቃውሞ ገጥሞታል። ጠቅላይ ሚኒስቴር ዶክተር ዐቢይ አህመድ፤ ፕሬዚዳንት ጆ ባይደን ትዕዛዙን ከፈረሙ ከጥቂት ሰዓታት በኋላ ለፕሬዚዳንቱ በጻፉት ግልፅ ደብዳቤ፤ “ተስፋ በቆረጡና ከሚሊዮኖች ደህንነት ይልቅ የእነሱ ስልጣን በሚያስጨንቃቸው ግለሰቦች የተሳሳተ መረጃ  የተነሳ በሚፈጠር ጫና አንበረከክም”  ብለዋል። ቻይና በበኩሏ፤ አሜሪካ በኢትዮጵያ ላይ ልትጥል ያሰበችውን አዲስ ማዕቀብ እንደምትቃወም ስታውቃለች። የቻይና የውጭ ጉዳይ ሚኒስቴር ቃል አቀባይ ሊጂያን ዥዋ፤ “አሜሪካ በኢትዮጵያ ላይ ልትጥል ያሰበችው አዲስ ማዕቀብ ቻይና ትቃወማለች” ሲሉ በትዊተር ገፃቸው አስፍረዋል። ኢትዮጵያ ልዩነቶችን ለመፍታትና ሀገራዊ መግባባትን ለመፍጠር፣ ሰላምና ፀጥታን ለማረጋገጥ አቅሙም ጥበቡም  እንዳላት  ናምናለን ያሉት ቃል አቀባዩ፤ አሜሪካ በጥንቃቄ ገንቢ ሚናዋን ትወጣለች ብለን እናምናለን ብለዋል። ጠቅላይ ሚኒስተር ዐቢይ በፃፉት ግልጽ ደብዳቤ፤ ህወኃት በኢትዮጵያ ላይ በፈፀማቸው ግፎችና በደሎች በርካታ ንፁሀን እየተገደሉ፣ ከቤት ንብረታቸው እየተፈናቀሉና ኑሮቸአው የተመሰቃቀለ እንዲሆን ሲደረግ እያየ የጆ ባይደን አስተዳደር፣ ጠንከር ያለ አቋም ሳይወስድ መቆየቱ መልስ ያጣ ጥያቄ ሆኗል ብለዋል። አሸበሪው የህወኃት ቡድን በትግራይ ክልል የሚገኙ ህፃናትን እንደ ከለላ አግቶ ይዞ እያሰቃያቸው መሆኑን ለፕሬዚዳንቱ የገለፁት ጠቅላይ ሚኒስትሩ፤ የክልሉን ህፃናት እያስገደዷቸው ወደ ጦርነት እየማገዳቸው እንደሆነና ይህም ድርጊት ቡድኑን በዓለም አቀፍ ህግ የሚያስጠይቀው ወንጀል ነው ብለዋል። እውነታው ይህ ሆኖ እያለ አለም አቀፉ ማህበረሰብ አይቶ እንዳላየ በመሆንና በተሳሳተ መረጃ ምክንያት ፊቱን ኢትዮጵያ ላይ አዙሯል ያሉት ጠቅላይ ሚኒስትሩ፤ የዚህ ሁሉ ምክንያት የሆነውን አሸባሪ ድርጅት ግን በተገቢው መንገድ መግሰፅና ማውገዝ አልተቻለም ብለዋል። “ተስፋ በቆረጡና ከሚሊዮኖች ደህንነት ይልቅ የእነሱ ስልጣን በሚያስጨንቃቸው ግለሰቦች የተሳሳተ መረጃ የተነሳ በሚፈጠር ጫና አንበረከክም፤ ኢትዮጵያዊነታችንና አፍሪካዊነታችን ይህ እንዲሆን አይፈቅድም” ሲሉ ጠቅላይ ሚኒስትሩ ፈርጠም ያለ አቋማቸውን አንፀባርቀዋል። አሜሪካ በኢትዮጵያ ላይ ልትጥል ያሰበችው አዲሱ ማዕቀብ ምን እንደሆነ በዝርዝር ባይገልፁትም ማዕቀቡ ቢጣልም በአገሪቱ ላይ የሚያስከትለው ጫና እዚህ ግባ የሚባል አይደለም ያሉት ፕሮፌሰር በየነ ጴጥሮስ፤ ማዕቀቡ ከማስፈራሪያነት የዘለለ ነገር አይኖረውም ሲሉም አጣጥለውታል። “አሜሪካ  ማእቀቡን እጥላለሁ ማለቷ የተለመደ ዛቻና ማስፈራሪያዋ ነው። እኛ የምንላችሁን ካልተቀበላችሁ፣  እንደምንላችሁ ካልሆናችሁ እንዲህ እናደርጋለን በማለት ጫና ለመፍጠር አስባ የምታደርገው ነው፡፡ ማእቀቡ ቢደረግም እንኳን ጉዳቱ የከፋ ነው የሚል እምነት የለኝም፣ እንደተነገረው ማእቀቡ በባለስልጣናቱ ላይ የቪዛ፣ በአሜሪካ አገር የሚገኝ የባለስልጣናት የሃብት መንቀሳቀስ ክልከላና የንብረት እገዳ ናቸው። ይህ እገዳ የሚያስከትለው ጉዳት ብዙ አይመስለኝም። ቀደም ባለው መንግስት በርካታ ባለስልጣናት በውጭ አገራት ገንዘብና ንብረት ያላቸው ስለነበሩ ይህንን ለማገድ ይጠቅም ይሆናል። ከለውጡ ወዲህ ግን ይህን አይነት ነገር እምብዛም የሚያሳስበን አይደለም እናም ማዕቀቡ ከማስፈራራት ያለፈ ብዙም  ጫና አለው ብዬ አላስብም፤ ይልቅ የአሜሪካንን ከእኛ በላይነትን የሚያሳይ ነው። ሲሉ ትዝብታቸውን ገልጸዋል። በመቀጠልም “አሜሪካኖች ካለነሱ ኢትዮጵያ ቆማ አትሄድም ልዕልናዋም ጥያቄ ውስጥ ይገባል ብለው ካሰቡ በጣም ተሳስተዋል። አሁን የዓለም ሁኔታ ተቀይሯል፤ እንደ ድሮው እዚህም እዚያም ጫና እያሳረፈን እንቀጥላለን ብለው ካሰቡ አይሰራም” ሲሉ ፕሮፌሰሩ። አስረድተዋል። አክለውም፤ ማዕቀቡን እንዴት መቋቋም እንደሚቻል ሲገልፁም፤ “አሁን አሜሪካ ባትደግፈን፣ ሌላ የሚደግፍ አገር ሞልቷል፤ እኛ ብቻ በአግባቡ ፖለቲካችንን መጫወት ብቻ ነው የሚጠበቅብን። የውስጥ ሁኔታዎችን ማስተካከል፣ ያሉብንን አለመረጋጋቶች መፍታት፣ ። የህግ የበላይነት እንዲስፍን ለማድረግ የተጀመረውን ህግ የማስከበር እንቅስቃሴ አጠናክሮ መቀጠልና አገራችንን በሰላማዊ ሁኔታ ውስጥ ማስቀመጥ፣ ሁሉም ሃይሎች ወደ ማምረት እንቅስቃሴ ውስጥ እንዲገቡ ሁኔታዎችን ማመቻቸት ይገባል ብለዋል” ፕሮፌሰር በየነ ጴጥሮስ።`,
      mediaSource: 'rec2',
      url: '/feeds/3',
    },

    {
      id: 4,
      avatar: 'ለ',
      title: 'ኢዜማ በጦርነት ለተፈናቀሉ ዜጎች ከ2 ሚ. ብር በላይ የሚገመት ድጋፍ አደረገ',
      date: 'መስከረም 2 2013',
      img: 'https://cdn.al-ain.com/images/2021/6/24/245-142433-ethiopian-citizens-for-social-justice-party_700x400.jpg',
      image_title: 'አጠቃላይ ወታደራዊ',
      description:
        'የኢትዮጵያ ዜጎች ለማህበራዊ ፍትህ (ኢዜማ)፤ በሰሜኑ የሃገሪቱ ክፍል ባለው ጦርነት ምክንያት ከሃብት ንብረታቸው...',
      content:
        'የኢትዮጵያ ዜጎች ለማህበራዊ ፍትህ (ኢዜማ)፤ በሰሜኑ የሃገሪቱ ክፍል ባለው ጦርነት ምክንያት ከሃብት ንብረታቸው ለተፈናቀሉ ዜጎች፣ የተለያዩ የቁስ ድጋፎችና እርዳታ እያደረገ መሆኑን  አስታውቋል። ፓርቲው በስልጣን ላይ ካለው መንግስት ጋር ያለውን የፖለቲካ ልዩነት ወደ ጎን አድርጎ፣  በህወሃት ጥቃት የተፈጸመባቸውን ዜጎች የመታደግ ተግባር ላይ መጠመዱን ያመለከተ ሲሆን በጎንደር፣ ። ደሴና አፋር ለሚገኙ ተፈናቃዮች ከ2 ሚሊዮን ብር በላይ የሚገመት ድጋፍ ማድረጉን አስታውቋል። ከሰሞኑም የህወሃት ሃይል የከፋ ጭፍጨፋ በፈጸመበት በሰሜን ጎንደር ጭና ቀበሌ  በመገኘት በከፍተኛ አመራሮቹ በኩል፣ ከአራት መቶ ሃምሳ ሺህ ብር በላይ የሚገመት ድጋፍ አድርጓል ተብሏል።በህውሃት ወራሪ ሃይል ከፍተኛ ጉዳት የደረሰባቸው ሴቶችና ህጻናት እንደመሆናቸው ፓርቲው የንጽህና መጠበቂያና አልባሳትን ነው ድጋፍ ያደረገው ብለዋል-የፓርቲው የፖሊሲ ጥናትና ምርምር ቡድን ዋና ሃላፊ ማስተዋል አስራደ። ኢዜማ ለወገኖቹ የሚያደርገው ድጋፍ በዚህ እንደማቆምና ቀጣይነት እንዳለውም ተናግሯል። ኢዜማ ከሰሜን ጎንደር በተጨማሪ በደሴና በአፋር ክልል ለሚገኙ የጦርነቱ ተጎጂዎችም ወደ የአካባቢዎቹ ባሰማራቸው ልኡካን አማካኝነት ድጋፍ ማድረጉን አስታውቋል።',
      mediaSource: 'rec3',
      url: '/feeds/4',
    },

    {
      id: 5,
      avatar: 'ን',
      title: 'ነፃ አስተያየት',
      date: 'ሰኔ 2 2011',
      img: 'https://images.unsplash.com/photo-1495020689067-958852a7765e?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTJ8fG5ld3N8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=60',
      image_title: 'በመቀየሩ ረገድ',
      description:
        'ምንም እንኳን ይህንን በመቀየሩ ረገድ በሥልጣን ላይ ያለው ፓርቲ ግንባር ቀደም ሃላፊነት ያለበት ቢሆንም፣ በርካታ የፖለቲካ ፣ ...',
      content: `አሜሪካ የኢትዮጵያን ሉአላዊነትና ነፃነት ልታከብር እንደሚገባና በህዝብ ተወካዮች ምክር ቤት በአሸባሪነት የተፈረጀውን የህውኃትንና የደጋፊዎቹን አገር የማተራመስ ተግባር በዓይነ ቁራኛ እንድትከታተል፣ የኢትዮጵያ አሜሪካውያን ዜጎች ምክር ቤት ጠይቋል።`,
      mediaSource: '../../assets/Media/Recommended/5.wav',
      url: '/feeds/5',
    },

    {
      id: 6,
      avatar: 'ማ',
      title: 'ርዕሰ አንቀፅ',
      date: 'መስከረም 2 2013',
      img: 'https://images.unsplash.com/photo-1588681664899-f142ff2dc9b1?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8bmV3c3xlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=60',
      image_title: 'በመቀየሩ ረገድ',
      description:
        'አንዳንድ ተረት ተደጋግሞ ካልተነገረን አንጀት አይደርስም።የሚከተለውን ተረት ከአመታት በፊት ተርከነዋል። ዛሬም እንተርከዋለን።  ትምህርታ...',
      content: ` ኢትዮጵያ በመጭው የክረምት ወራት በታላቁ ሕዳሴ ግድብ፣ የሙከራ ኃይል ማመንጨት እንደምትጀምር የውጭ ጉዳይ ሚኒስቴር  የገለጸ ሲሆን በመጭው ክረምት ሁለተኛው ዙር የውሃ ሙሌት በተያዘለት ጊዜ እንደሚካሄድም ተነግሯል፡፡`,
      mediaSource: '../../assets/Media/Recommended/6.wav',
      url: '/feeds/6',
    },

    {
      id: 7,
      avatar: 'ለ',
      title: 'ከአለም ዙሪያ',
      date: 'ጥር 2 2013',
      img: 'https://images.unsplash.com/photo-1505373877841-8d25f7d46678?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NXx8bmV3c3xlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=60',
      image_title: 'አጠቃላይ ወታደራዊ',
      description:
        'የአለማችን አጠቃላይ ወታደራዊ ወጪ ባለፈው በፈረንጆች አመት 2020 ወደ 2 ትሪሊዮን ዶላር ከፍ ማለቱንና ከሰሞኑ የወጣ አንድ ሪፖርት ...',
      content: `የአሜሪካ ሴኔት በኢትዮጵያ ትግራይ ክልል ውስጥ እየተካሄደ ነው ያለውን ግጭት አስመልክቶ ከትናንት በስቲያ ባካሄደው ዝግ ስብሰባ የውሳኔ ሃሳብ አሳልፏል`,
      mediaSource: '../../assets/Media/Recommended/',
      url: '/feeds/7',
    },

    {
      id: 8,
      avatar: 'ን',
      title: 'ተጠያቂነትን የሚፈራ መሪ',
      date: 'ሰኔ 2 2011',
      img: 'https://images.unsplash.com/photo-1495020689067-958852a7765e?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTJ8fG5ld3N8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=60',
      image_title: 'በመቀየሩ ረገድ',
      description:
        'ተጠያቂነት የሚፈራ መሪ፣የቤት ስራውን ሳይሰራ እንደሚቀመጥ ሰነፍ ተማሪ ነው። ከተጠያቂነት የሚሸሹ መሪዎች፤ ለዜጎቻቸው የስራ ሪፖርት ማሰማትም  ...',
      content: `ተጠያቂነት የሚፈራ መሪ፣የቤት ስራውን ሳይሰራ እንደሚቀመጥ ሰነፍ ተማሪ ነው። ከተጠያቂነት የሚሸሹ መሪዎች፤ ለዜጎቻቸው የስራ ሪፖርት ማሰማትም ሆነ ለውይይት መጋበዝ አይፈልጉም፡፡ጋዜጣዊ መግለጫን እንደ ጦር ይፈሩታል፡፡`,
      mediaSource: '../../assets/Media',
      url: '/feeds/8/Recommended/',
    },
    {
      id: 9,
      avatar: 'ን',
      title: 'አንተ ከነብሩ ጋር ነህ ወይስ ከእኔ ጋር?',
      date: 'ሰኔ 15 2005',
      img: 'https://images.unsplash.com/photo-1495020689067-958852a7765e?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTJ8fG5ld3N8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=60',
      image_title: 'በመቀየሩ ረገድ',
      description:
        'ወዳጅና ጠላታችንን ሳንለይ ጉዞ መጀመር የዋህነት ነው። ምክንያቱም አላማችንም ሆነ ኢላማችን በቅርቡ ፣ ...',
      content: `ከእለታት አንድ ቀን፣ አንድ አዳኝ ነብር። የሚያድነው ወደ ጫካ ሄዶ ነው።`,
      mediaSource: '../../assets/Media/Recommended/',
      url: '/feeds/9',
    },
    {
      id: 10,
      avatar: 'ብ',
      title: 'የልጆች ሥነልቦና እና ኮሮና',
      date: 'ሰኔ 5 2011',
      img: 'https://images.unsplash.com/photo-1495020689067-958852a7765e?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTJ8fG5ld3N8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=60',
      image_title: 'በመቀየሩ ረገድ',
      description:
        'ጥናቱ እንደሚያመለክተው፤ ልጆች ሙሉ ለሙሉ አልያም በከፊል በቤት ውስጥ ቢያንስ ለዘጠኝ ወራት ፣ ...',
      content: `ጥናቱ እንደሚያመለክተው፤ ልጆች ሙሉ ለሙሉ አልያም በከፊል በቤት ውስጥ ቢያንስ ለዘጠኝ ወራት መቀመጣቸው  ከፍተኛ ለሆነ ሥነልቦናዊ ቀውስ ያጋልጣቸዋል። ዩኒሴፍ በዚህ ጥናቱ`,
      mediaSource: '../../assets/Media/Recommended/',
      url: '/feeds/10',
    },
    {
      id: 11,
      avatar: 'ን',
      title: 'የቢሊየነሮቹ ጥንዶች ድንገተኛ ፍቺ!',
      date: 'ሰኔ 2 2011',
      img: 'https://images.unsplash.com/photo-1495020689067-958852a7765e?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTJ8fG5ld3N8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=60',
      image_title: 'በመቀየሩ ረገድ',
      description:
        'የዓለማችን ሁለቱ ተፅዕኖ ፈጣሪ ቢሊየነሮች ፍቺ  የዓለማቀፍ ሚዲያዎች ዋነኛ አጀንዳ ሆኖ ነው የሰነበተው ...',
      content: `ቢሊየነሮቹ ቢል ጌትስና ሜሊንዳ ጌትስ ባለፈው ሳምንት ፍቺ (ሜይ 3) ለመፈፀም መወሰናቸውን ይፋ ሲያደርጉ ብዙዎች ተደናግጠዋል።`,
      mediaSource: '../../assets/Media/Recommended/',
      url: '/feeds/11',
    },
    {
      id: 12,
      avatar: 'ን',
      title: 'ተስፋ ሰጪ የኮቪድ መድሃኒት መገኘቱ ተነገረ',
      date: 'ሰኔ 2 2011',
      img: 'https://images.unsplash.com/photo-1495020689067-958852a7765e?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTJ8fG5ld3N8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=60',
      image_title: 'በመቀየሩ ረገድ',
      description:
        'ምንም እንኳን ይህንን በመቀየሩ ረገድ በሥልጣን ላይ ያለው ፓርቲ ግንባር ቀደም ሃላፊነት ያለበት ቢሆንም፣ በርካታ የፖለቲካ ፣ ...',
      content: `   የአውስትራሊያው ግሪፍዝ ዩኒቨርሲቲና ካሊፎርኒያ ከሚገኘው ሲቲ ኦፍ ሆፕ የካንሰር ምርምር ማዕከል የተውጣጡ ሳይንቲስቶች ከሰሞኑ ይፋ ያደረጉትን የምርምር ውጤት ጠቅሶ ዘገባው እንዳለው፣ ሳይንቲስቶቹ አግኝተነዋል ያሉት ጸረ-ቫይረስ መድሃኒት በኮሮና ቫይረስ በተጠቁ አይጦች ላይ ተሞክሮ ቫይረሱን እንዳይባዛ በማድረግና በመግደል ረገድ ውጤታማ መሆኑ ተረጋግጧል፡፡
      `,
      mediaSource: '../../assets/Media/Recommended/',
      url: '/feeds/12',
    },
    {
      id: 13,
      avatar: 'ን',
      title: 'የ3 ደቂቃ የህሊና ፀሎት የሚነፈጉም አሉ!',
      date: 'ሰኔ 2 2011',
      img: 'https://images.unsplash.com/photo-1495020689067-958852a7765e?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTJ8fG5ld3N8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=60',
      image_title: 'በመቀየሩ ረገድ',
      description:
        'ምንም እንኳን ይህንን በመቀየሩ ረገድ በሥልጣን ላይ ያለው ፓርቲ ግንባር ቀደም ሃላፊነት ያለበት ቢሆንም፣ በርካታ የፖለቲካ ፣ ...',
      content: `ለምሳሌ የኒውዮርኩ የንግድ ማዕከል በቦምብ ከመጋየቱ አንድ ሳምንት ቀደም ብሎ በአንጎላ በባቡር ይጓዙ የነበሩ 500 ሰዎች በጅምላ ተጨፍጭፈዋልበአልጀሪያ በርካታ ህጻናትና እንስቶች በአክራሪ ቡድኖች አንገታቸው ሲቀላ ማን አስታወሳቸው`,
      mediaSource: '../../assets/Media/Recommended/',
      url: '/feeds/13',
    },
    {
      id: 14,
      avatar: 'ን',
      title: 'የሰበታው ቱሉ መገርሳ ሆቴል ይመረቃል',
      date: 'ሰኔ 2 2011',
      img: 'https://images.unsplash.com/photo-1495020689067-958852a7765e?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTJ8fG5ld3N8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=60',
      image_title: 'በመቀየሩ ረገድ',
      description:
        'ምንም እንኳን ይህንን በመቀየሩ ረገድ በሥልጣን ላይ ያለው ፓርቲ ግንባር ቀደም ሃላፊነት ያለበት ቢሆንም፣ በርካታ የፖለቲካ ፣ ...',
      content: `በሰበታ ከተማ ቀበሌ 04 የሚገኘው “ቱሉ መገርሳ ኢንተርናሽናል ሆቴል” ከዛሬ ጀምሮ ለተከታታይ ዘጠኝ ቀናት እንደሚመረቅ ወጣቱ ባለሃብት አቶ ጅሩ መገርሳ ገለፁ`,
      mediaSource: '../../assets/Media/Recommended/',
      url: '/feeds/14',
    },
  ],
  ስፖርት: [
    {
      id: 20,
      avatar: 'ን',
      title:
        'የኢትዮጵያ ፕሪሚየር ሊግ አሸናፊ ፋሲል ከነማና የዋሊያዎቹ የፊት መስመር ተጨዋች ሙጂብ ቃሲም ባለፈው የውድድር ዓመት ስኬታማ ተጨዋች ነበር',
      date: 'ሰኔ 2 2011',
      img: 'https://ichef.bbci.co.uk/news/728/cpsprodpb/0F7C/production/_118546930_800.jpg',
      image_title: 'ፕሪሚየር ሊግ',
      description:
        'የኢትዮጵያ ፕሪሚየር ሊግ አሸናፊ ፋሲል ከነማና የዋሊያዎቹ የፊት መስመር ተጨዋች ሙጂብ ቃሲም ባለፈው የውድድር ዓመት ስኬታማ ተጨዋች ነበር፡፡ የተጨዋቹን እንቅስቃሴ የተመለከቱ የውጭ ክለቦች በተለይም የአልጀሪያው ጄኤል ካቢሌ ሙጂብን በቋሚነት ለማዘዋወር ባቀረበው ጥያቄ መሠረት ዝውውሩ ተሳክቷል ከተባለ በኋላ ዝውውሩ እክል ስለገጠመው አሁን ላይ ተጨዋቹ ፊቱን ወደ አገር ውስጥ ሊግ ማዞሩ እየተነገረ ይገኛል፡፡',
      content: `የኢትዮጵያ ፕሪሚየር ሊግ አሸናፊ ፋሲል ከነማና የዋሊያዎቹ የፊት መስመር ተጨዋች ሙጂብ ቃሲም ባለፈው የውድድር ዓመት ስኬታማ ተጨዋች ነበር፡፡ የተጨዋቹን እንቅስቃሴ የተመለከቱ የውጭ ክለቦች በተለይም የአልጀሪያው ጄኤል ካቢሌ ሙጂብን በቋሚነት ለማዘዋወር ባቀረበው ጥያቄ መሠረት ዝውውሩ ተሳክቷል ከተባለ በኋላ ዝውውሩ እክል ስለገጠመው አሁን ላይ ተጨዋቹ ፊቱን ወደ አገር ውስጥ ሊግ ማዞሩ እየተነገረ ይገኛል፡፡

      ሙጂብ ከአልጀሪያው ክለብ ጋር በምን ዓይነት ስምምነት እንደሚቀጥል በተወካዩ በኩል መጠናቀቁ ከተነገረ በኋላ ፡፡  ስምምነቱ ለሙከራ በሚል ምክንያት ዝውውሩ ሊበላሽ እንዴት ቻለ? የሚል ጥያቄ እያስነሳ ይገኛል፡፡ ምክንያቱም የዓለም እግር ኳስ አስተዳዳሪ ፊፋ ሆነ አኅጉራዊው ተቋም ካፍ በክለቦችና በተጨዋቾች መካከል ሊኖር የሚገባው ፡፡  ድርድርና ስምምነት በምን ሁኔታ እንደሚጠናቀቅ በግልጽ ያስቀመጡት ደንብና መመርያ መቀመጡን የሚገልጹ አንዳንድ ፡፡ ወገኖች ለሙጂብ ቃሲም ዝውውር መበላሸት የክለቦችና የተጨዋቾች ወኪል ነን የሚሉ አካላት የስምምነቱን ዓይነትና ምንነት  በመረዳቱ ረገድ የአቅም ውስንነት ሊሆን እንደሚችል አልሸሸጉም፡፡ `,
      mediaSource: 'sport',
      url: '/feeds/20',
    },
    {
      id: 21,
      avatar: 'ን',
      title: '"40 ዓመትም ቢሆን ለማራቶን ውድድር ትልቅ አይደለም" ቀነኒሳ በቀለ',
      date: 'ሰኔ 2 2011',
      img: 'https://ichef.bbci.co.uk/news/800/cpsprodpb/1211B/production/_120711047_bekele_getty_1342705897.jpg',
      image_title: 'በመቀየሩ ረገድ',
      description:
        'ሰኔ ወር ላይ ሰላሳ ዘጠኝ ዓመቱን ያከበረው ቀነኒሳ በኬንያዊው ኤሊዩድ ኪፕቾጌ የተያዘውን ሁለት ሰዓት ከአንድ ደቂቃ ከ ሰላሳ ዘጠኝ...',
      content: `ሰኔ ወር ላይ ሰላሳ ዘጠኝ ዓመቱን ያከበረው ቀነኒሳ በኬንያዊው ኤሊዩድ ኪፕቾጌ የተያዘውን ሁለት ሰዓት ከአንድ ደቂቃ ከ ሰላሳ ዘጠኝ ሰኮንድ የማራቶን ክብረ ወሰን ለመስበር እንዳቀደም ይናገራል። ሆኖም በባለፈው ሳምንት መጨረሻ በበርሊን በተደረገው ውድድር ከኪፕቾጌ የክብረ ወሰን ሰዓት። ከአምስት ደቂቃዎች በላይ ዘግይቶ እንዲሁም ውድድሩን ካሸነፈው እና ከአገሩ ልጅ ጉዬ አዶላ አንድ ደቂቃ ዘግይቶ ነበር ውድድሩን በሦስተኛነት ያጠናቀቀው። የሦስት ጊዜ የኦሎምፒክ ሻምፒዮና ቀነኒሳ በአሁኑ ወቅት ትኩረቱ በሚቀጥለው ዓመት በጀርመን መዲና በርሊን በሚካሄደው የማራቶን ውድድር ክብረ። ወሰኑን መስበር ቢሆንም በፓሪስ የሚደረገውን የ ሁለት ሺህ ሃያ አራት ኦሎምፒክም እንደሚሳተፍ ፍንጭ ሰጥቷል። "ከበርካታ አትሌቶች በዚህ ዕድሜ፣ አርባ ጥሩ ውጤት ሊያመጡ እንደሚችሉ መረጃ አለኝ። ለማራቶን ውድድር ትልቅ አይደለም" ብሏል።" ጤነኛ ከሆንኩ እና ከተዘጋጀሁ በበርሊን በሚደረገው የማራቶን ውድድር ክብረ ወሰን ለማሻሻል እሮጣለሁ" በማለት ተናግሯል። ከወራት በፊት በኮሮናቫይረስ ተይዞ ያገገመው ቀነኒሳ የበርሊኑ ማራቶን ውድድር ላይም ህመሙ ጥሎብት ባለፈው ጫና ያሰበውን ሳያሳካ እንደቀረም አስረድቷል።`,
      mediaSource: 'sport2',
      url: '/feeds/21',
    },
    {
      id: 22,
      avatar: 'ን',
      title: 'ኢትዮጵያውያኑ ጎተይቶም ገብረ ስላሴና ጉዬ አዶላ በበርሊን ማራቶን አሸናፊ ሆኑ',
      date: 'ሰኔ 2 2011',
      img: 'https://ichef.bbci.co.uk/news/800/cpsprodpb/B8C3/production/_120699274_mediaitem120699273.jpg',
      image_title: 'በመቀየሩ ረገድ',
      description: 'በሴቶች የማራቶን ውድድር ከአንደኛ እስከ ሶስተኛ ስፍራ የያዙት ኢትዮጵያውያን ናቸው...',
      content: `በሴቶች የማራቶን ውድድር ከአንደኛ እስከ ሶስተኛ ስፍራ የያዙት ኢትዮጵያውያን ናቸው። በወንዶች የማራቶን ውድድር ከፍተኛ ግምት የተሰጠውና ከወራት በፊት ከኮሮናቫይረስ ህመም ያገገመው ቀነኒሳ በቀለ በሶስተኛነት አጠናቋል። ጉዬ አዶላ በ ሁለት ሰዐት ከአምስት ደቂቃ የአሸናፊነቱን ስፍራ ሲይዝ ኬንያዊው የጎን ቤትዌል ሁለተኛ፣ ቀነኒሳ በቀለ ሶስተኛ፣ ታዱ አባተ አራተኛ ስፍራን ይዟል። የ ሰላሳ አመቱ ጉዬ አዶላ ከዚህ ቀደም በበርሊን ማራቶን የመጀመሪያ በሆነው ውድድን የአለም ክብረ ወስንንና ሁለት ጊዜ የአለም ሻምፒዮና ከሆነው ኢሉይድ ኪፕቾጌን በመከተል ሁለተኛ ወጥቷል። በሴቶች ማራቶን ውድድር አሸናፊ የሆነችው ጎተይቶም ገብረሥላሴ የበርሊን የማራቶን ውድድር የመጀመሪያዋ ነው። ጎተይቶም ይህንን ውድድር በ ሁለት ሰዓት ከአንድ ደቂቃ ስታጠናቀቅ ሕይወት ገብረ ኪዳን በ ሁለት ሰዓት ከአንድ ደቂቃ ሰከንድ ሁለተኛ በማሸነፍ የብር ሜዳሊያዋን አሸንፋለች። በሶስተኛ ደረጃም ኢትዮጵያዊቷ ቶላ በሶስተኛነት ውድድሩን አጠናቃለች።
`,
      mediaSource: 'sport3',
      url: '/feeds/22',
    },
    {
      id: 23,
      avatar: 'ን',
      title: 'የፀረ-አበረታች ኤጀንሲ በአትሌቲክስ ውስጥ የካናቢስን መታገድ ሊመረምር ነው',
      date: 'ሰኔ 12 2013',
      img: 'https://ichef.bbci.co.uk/news/624/cpsprodpb/0A24/production/_120569520_mediaitem119291865.jpg',
      image_title: 'በመቀየሩ ረገድ',
      description:
        'የዓለም ፀረ-አበረታች ንጥረ ነገሮች ተቆጣጣሪ ኤጀንሲ የሆነው ዋዳ በአትሌቲክስ ውስጥ የካናቢስን መከልከል ዳግም ሊመረምር ነው...',
      content: `የዓለም ፀረ-አበረታች ንጥረ ነገሮች ተቆጣጣሪ ኤጀንሲ የሆነው ዋዳ በአትሌቲክስ ውስጥ የካናቢስን መከልከል ዳግም ሊመረምር ነው። ኤጀንሲው ይህን የሚያደርገው አሜሪካዊቷ የአጭር ርቀት ተወዳዳሪ የካናቢስ ምርመራ ማለፍ ባለመቻሏ በቶኪዮ ኦሊምፒክ ሳትሳተፍ ከቀረች በኋላ ነው። የ ሀያ አንድ ዓመቷ ሻካሪ ሪቻርደሰን የወላጅ እናቷን ሞት ተከትሎ ሐዘኗን ለመቋቋም ካናቢስ መጠቀሟን ይፋ አድርጋ ነበር። የዓለም ፀረ-አበረታች ንጥረ ነገሮች ኤጀንሲ በካናቢስ ዙሪያ ሳይንሳዊ ምርመራ በቀጣይ የፈረንጆች ዓመት እንደሚጀመር ገልጾ፤ ካናቢስ በአትሌቲክስ ውስጥ የተከለከለ ሆኖ አስከ ሁለት ሺህ ሀያ ሁለት ይቀጥላል ብሏል። የፀረ-አበረታች ኤንጀንሲው በካናቢስ ላይ ያለው ሕግ ዳግም ማጤን ያስፈለው "ከሚመለከታቸው በርካታ አካላት ጥያቄዎች በመቅረባቸው ነው" ብሏል።  ሪቻርድሰን ሰኔ ወር ላይ ለቶኪዮ ኦሊምፒክ ማጣሪያ በአሜሪካ በተደረገ ውድድር በ መቶ ሜትር ማሸነፍ ችላ ነበር። በዚህም በማጣሪው ግማሽ ፍጻሜ ውድድር ላይ ያጠናቀቀችበት ሰዓት ስድስተኛው በሴቶች የተመዘገበ ፈጣን ሰዓት ሆኖ ተመዝግቦ ነበር።   የአትሌቷ የካናቢስ ምርመራ ውጤት 'ፖዘቲቭ' የሆነው በኦሊምፒክ ማጣሪያ ላይ ሲሆን፤ በማጣሪያ ውድድር ላይ ያስመዘገበችው ፈጣኑ ሰዓትም ውድቅ ተደርጎባታል። የአንድ ወር እገዳም ተጥሎባታል። ሪቻርድሰን የተካፈለችበት ማጣሪያ ውድድር የተካሄደው ከወላጅ እናቷ ሞት ከአንድ ሳምንት በኋላ ነበር። 
`,
      mediaSource: 'sport4',
      url: '/feeds/23',
    },
    {
      id: 24,
      avatar: 'ን',
      title: 'ማንችስተር ሲቲ የእንግሊዝ ፕሪምየር አሸናፊ ሆነ',
      date: 'ሰኔ 2 2011',
      img: 'https://ichef.bbci.co.uk/news/800/cpsprodpb/17B53/production/_118470179_9ecc39db-af9f-4415-9602-5e67f9aea5a4.jpg',
      image_title: 'በመቀየሩ ረገድ',
      description:
        'ማንችስተር ሲቲ በአራት ዓመታት ውስጥ ለሶስተኛ ጊዜ የዘንድሮው የእንግሊዝ ፕሪምየር ሊግ አሸናፊ ሆኗል።',
      content: `ማንችስተር ሲቲ በአራት ዓመታት ውስጥ ለሶስተኛ ጊዜ የዘንድሮው የእንግሊዝ ፕሪምየር ሊግ አሸናፊ ሆኗል።
`,
      mediaSource: '../../assets/Media/Sports/',
      url: '/feeds/24',
    },
    {
      id: 25,
      avatar: 'ን',
      title: "አትሌቲክስ ፌደሬሽን፡ 'በኦሊምፒክ የሚሳተፉ ሯⶐች የሚመረጡት በቴክኒክ ኮሚቴ ነው' አለ",
      date: 'ሰኔ 2 2011',
      img: 'https://ichef.bbci.co.uk/news/800/cpsprodpb/174B8/production/_118461459_f701f9f0-fcfa-4c2c-98c8-801a64e72d4a.jpg',
      image_title: 'በመቀየሩ ረገድ',
      description:
        'በቶኪዮ 2020 ኦሊምፒክ ኢትዮጵያን ወክለው በማራቶን የሚወደዳሩ አትሌቶችን የሚመርጠው ብሔራዊ የቴክኒክ ኮሚቴ እንዲሆን ከስምምነት መደረሱን የኢትዮጵያ አትሌቲክስ ፌዴሬሽን አስታወቀ።',
      content: `በቶኪዮ 2020 ኦሊምፒክ ኢትዮጵያን ወክለው በማራቶን የሚወደዳሩ አትሌቶችን የሚመርጠው ብሔራዊ የቴክኒክ ኮሚቴ እንዲሆን ከስምምነት መደረሱን የኢትዮጵያ አትሌቲክስ ፌዴሬሽን አስታወቀ።
`,
      mediaSource: '../../assets/Media/Sports/',
      url: '/feeds/25',
    },
  ],
  መዝናኛ: [],
  ቴክ: [
    {
      id: 30,
      avatar: 'ን',
      title:
        'ቢያንስ በ53 ሺህ ይህ ተህዋስ የተገጠመላቸው የቴክኖ ስልኮች ኢትዮጵያ፣ ካሜሩን፣ ግብፅ፣ ጋና እና ደቡብ አፍሪካ ውስጥ መሸጣቸው ተነግሯል።',
      date: 'ሰኔ 2 2011',
      img: 'https://huleaddis.com/newsweb/files/images/medium_1598428627499.jpeg',
      image_title: 'tech ረገድ',
      description:
        'ኮምፒውተር ተህዋስ [ማልዌር] የተገጠመላቸው በሺዎች የሚቆጠሩ የቻይና ስሪት የሆኑ ስልኮች አፍሪካ ውስጥ መቸብቸባቸው ተሰምቷል።',
      content: `የኮምፒውተር ተህዋስ የተገጠመላቸው በሺዎች የሚቆጠሩ የቻይና ስሪት የሆኑ ስልኮች አፍሪካ ውስጥ መቸብቸባቸው ተሰምቷል። አፕስትሪም የተሰኘ አንድ ተቋም ነው ይህን ይፋ ያደረገው። የስልኮቹ አምራች የሆነው ትራንዚሽን የተሰኘ ኩባንያ ተህዋሱ የተገጠመው ከእኔ እውቅና ውጪ በአከፋፋዮች ነው ይላል። አፕስትሪም የተሰኘው የመሰል ተህዋሶች አጋላጭ ድርጅት በዚህ አይስማማም። "ይህ ማልዌር ሚሊዮኖችና ገቢያቸው አናሳ የሆኑ ሰዎች በሚገዙት ስልክ ላይ መሰል ተህዋስ ያለ ተጠቃሚዎች መገጠሙ ኢንዱስትሪው ምን ያክል የሰዎችን ግላዊነት እየተጋፋ እንዳለ የሚያሳይ ነው" ይላሉ የአፕስትሪም ባለሙያ የሆኑት ጄፍሪ ክሊቭስ። 'ትሪያዳ' የተሰኘው ተህዋስ አንድሮይድ ተንቀሳቃሽ ስልኮች ላይ የሚገጠም ሲሆን 'ኤክስሄልፐር' የተባለ ኮድ ተጠቅሞ ከተጠቃሚዎች እውቅና ውጪ ያሻውን የሚያደርግ ነው። የሰዎችን ማንነት የሚለየው ቴክኖሎጂ እያከራከረ ነው ሞና ሊሳ "ነፍስ ዘራች" ሰዎችን በፊት ገጽታቸው "ጉግል" ማድረግ ሊጀመር ነው ይህ ማልዌር ብዙ ጊዜ ተጠቃሚዎች ሳያውቁ አገልግሎት ሰጪ ድርጅቶችን የሚቀላቀል ነው። ይህ ተህዋስ ሞባይል ስልክዎ ላይ ያለዎትን ገንዘብ [የአየር ሰዓት] ያለ ፈቃድዎ የሚወስድ ነው። በርካታ የአፍሪካ አገራት ውስጥ የበይነ መረብ ክፍያ የሚፈፀመው በአየር ሰዓት ነው። ትራንዚሽን ሆልዲንግስ የተሰኘው ተንቀሳቃሽ ስልክ አምራች ኩባንያ ቻይና ውስጥ ካሉ ግዙፍ ኩባንያዎች አንዱ ሲሆን አፍሪካ የምርቶቹ ቁጥር አንድ ገዢ ናት። 
`,
      mediaSource: 'tech',
      url: '/feeds/30',
    },
  ],

  መጽሃፍት: [
    {
      id: 31,
      avatar: 'ን',
      title: 'ዮቶር',
      date: 'ሰኔ 2 2011',
      img: 'https://www.mereb.shop/Image/Product/56002319/56002319-42-450-extraLarge.jpg',
      image_title: 'ዮቶር',
      description: 'ዮቶር - ክፍል አንድ ኮብላይ ከሀን',
      content: `
      ዮቶር ክፍል 1::
            ኮብላይ ካህን::

የሰው ልጅ አብዝቶ የሚያስበው ሁለት ነገሮችን ይመስለኛል፡፡ የመጀመሪያው ሊያገኘው የሚመኘውንና የራቀበትን ሁለተኛው ደግሞ የሚሳሳለትንና እንዳያጣው የሚሰጋውን ነገር ነው ብዬ አስባለሁ፡፡ እኔም የአዳም ልጅ ነኝና አብዝቼ አጨነቃለሁ፡፡ የምሳሳለትና እንዳላጣው የምሰጋውም ነገር እለኝ፡፡ የምመኘውና ላገኘው ያልቻልኩት ነገርም እለኝ፡፡
ዛሬ ከባዱን ጭንቀቴን ይበልጥ አከብጄ ልጨነቅበት ከተማዬን ሸሽቼ ሰው ከማይደርስበት ጫካ መሃል ከአንዲት ትንሽ ጅረት አጠገብ ድንጋይ ላይ ተቀምጫለሁ፡፡ ከሰላሳ ዓመታት በላይ አዚህቸ ምድር ላይ ኖሬያለሁ፡፡ የምፈልገውንም  ለማግኘት ብዙ ወጥቼ ወርጃለሁ ግን በመንገዴ ላይ አንዳለሁ ቢሰማኝም የተጓዝኩት ቅርብ ነው፡፡  ያለመጓዝን ያህል የቀረበ መንገድ ፡፡  ያሰብኩት
ሩቅ ለመጓዝ ነበር፡፡ ለመድረስ ያሰብኩበት ሥፍራ ከአድማሱም በላይ ርቆ ይታየኛል፡፡ አንዳንዴ ትንፋሽ ለመሰብሰብ መንገዴ ላይ ቁጢጥ ብዬ "የሆነ አቋራጭ መንገድ ይኖር ይሆን?” እላለሁ፡፡ አቋራጭ መንገድ ገጥሞኝ ባያውቅም፡፡
`,
      mediaSource: 'book',
      url: '/feeds/31',
    },
  ],
};

export default data;
